module.exports = __webpack_public_path__ + "static/media/icon-arrow.93e07961.png";